import CRUDActions from './CRUD';
import Event from '../api/event';
import { factory } from '../api/voting';

class EventCRUDActions extends CRUDActions {
  prefix = 'event';

  get _model() {
    return Event;
  }

  get saveVotingAction() {
    return this.prefix + '_save_voting';
  }

  get saveVotingSuccessAction() {
    return this.saveVotingAction + '_success';
  }

  get saveVotingFailedAction() {
    return this.saveVotingAction + '_failed';
  }

  get publishVotingAction() {
    return this.prefix + '_publish_bingo';
  }

  get publishVotingSuccessAction() {
    return this.publishVotingAction + '_success';
  }

  get publishVotingFailAction() {
    return this.publishVotingAction + '_fail';
  }

  get announceResultVotingAction() {
    return this.prefix + '_announce_result_bingo';
  }

  get announceResultVotingSuccessAction() {
    return this.announceResultVotingAction + '_success';
  }

  get announceResultVotingFailAction() {
    return this.announceResultVotingAction + '_fail';
  }

  save(data) {
    return async (dispatch, getState) => {
      let { event: { model } } = getState();

      return await dispatch(super.save(model, data));
    }
  }

  /**
   *
   * @param string  votingType
   * @param object data
   * @returns {function()}
     */
  saveVoting(votingType, data) {
    return async (dispatch, getState) => {
      let { event: { model }} = getState();
      /** @var Voting voting */
      let voting = model[Event.getEventAttr(votingType)];

      if (voting) {
        voting._extendData(data);
      } else {
        voting = this._createEventModel(votingType, data)
      }

      dispatch({
        type: this.saveVotingAction,
        votingType
      });

      try {
        voting.eventId = model.id;

        voting = await voting.save();

        dispatch({
          type: this.saveVotingSuccessAction,
          votingType,
          voting
        });

        return voting;
      }
      catch (error) {
        dispatch({
          type: this.saveVotingFailedAction,
          votingType,
          error
        });
        throw error;
      }
    }
  }

  _createEventModel(type, data) {
    return new (factory(type))(data);
  }

  publishVoting(votingType, data) {
    return async (dispatch, getState) => {
      let { event: { model } } = getState();
      /** @var Voting voting */
      let voting = model[ Event.getEventAttr(votingType) ];

      dispatch({
        type: this.publishVotingAction,
        votingType
      });

      try {
        voting._extendData(data);

        voting = await voting.save();
        voting = await voting.publish();

        dispatch({
          type: this.publishVotingSuccessAction,
          votingType,
          voting
        });
        return voting;
      }

      catch (error) {
        /* eslint no-console: 0 */
        console.error(error);

        dispatch({
          type: this.publishVotingFailAction,
          votingType,
          error
        });
      }
    };
  }

  announceResultVoting(votingType, data) {
    return async (dispatch, getState) => {
      let { event: { model } } = getState();
      /** @var Voting voting */
      let voting = model[ Event.getEventAttr(votingType) ];

      dispatch({ type: this.announceResultVotingAction, votingType });

      try {
        await voting.announceResult(data);

        dispatch({
          type: this.announceResultVotingSuccessAction,
          votingType,
          voting
        })
      }

      catch (error) {
        /* eslint no-console: 0 */
        console.error(error);

        dispatch({
          type: this.announceResultVotingFailAction,
          votingType,
          error
        });
      }
    }
  }

}

export default new EventCRUDActions();



// WEBPACK FOOTER //
// ./src/actions/event.js